import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import axios from 'axios'
import "bootstrap-vue/dist/bootstrap-vue.css";
//import { TablePlugin, /*BTable,*/ BPagination, BModal } from 'bootstrap-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import $JExcel from '@/utils/_myexcel.js'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { CONFIG_REQUEST } from "@/store/actions/config";
import { USER_REQUEST } from "@/store/actions/user";

const VueInputMask = require('vue-inputmask').default;

Vue.use(VueInputMask);
//Vue.use(VueSelect);
//Vue.use(TablePlugin);
//Vue.use(FormDatepickerPlugin);

Vue.prototype.$http = axios;
Vue.prototype.$JExcel = $JExcel;
Vue.prototype.jQuery = window.$;

//Vue.component('b-table', BTable);
//Vue.component('b-pagination', BPagination);
//Vue.component('b-modal', BModal);
Vue.component('datepicker', DatePicker);
Vue.component('v-select', vSelect);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


Vue.config.productionTip = false;

store.dispatch(CONFIG_REQUEST)
  .then(() => {
    store.dispatch(USER_REQUEST)
      .then(() => { })
      .catch(() => { })
      .finally(() => {
        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app');
      })
  });
